import * as React from 'react';
import { DocumentViewer } from './DocumentViewer';
import { FAIcon } from '../FAIcon';
import { Notification } from '../Notification';
import { APIDocumentContainer, APIDocumentType, DocumentContainerAPI } from '../../../api/documentContainer';

import './table-definitions-editor.scss';

interface Props {
  setShowEditDefinitions: (value: boolean) => void;
  document: APIDocumentContainer;
  pdfDocument: any;
  filename: string | undefined;
  setNotification: (notification: Notification | null) => void;
  showSpinner: boolean;
  filePages?: number[] | null;
  documentTypes?: APIDocumentType[];
  reloadGroupData?: () => Promise<void>;
  groupId?: number;
  activePage: number;
}

export const TableDefinitionsEditor: React.FC<Props> = (props) => {
  const [cancelEditTrigger, setCancelEditTrigger] = React.useState(0);
  const [previewChangesTrigger, setPreviewChangesTrigger] = React.useState(0);

  const fileType = props.documentTypes && props.documentTypes.find((type) => { return type.id === props.document.documentType });
  const fileTypeLabel = fileType ? fileType.cwCode : "MSC";

  return (
    <div className='table-definitions-editor'>
      <div className='table-definitions-editor-wrapper'>
        <div className='table-definitions-editor-header'>
          <div className='table-definitions-editor-document'>
            <div className={`table-definitions-document-type ${fileTypeLabel}`}>
              <FAIcon name="file" />
              {fileTypeLabel}
            </div>
            <div className='table-definitions-document-filename'>
              {props.filename}
            </div>
          </div>
          <div className='table-definitions-editor-pagination'>
            Page {props.activePage + 1}
          </div>
          <div className='table-definitions-editor-actions'>
            <button
              className='light-button'
              onClick={() => {
                setCancelEditTrigger(cancelEditTrigger + 1);
              }}
            >
              Cancel
            </button>
            <button
              className='full-button'
              onClick={() => {
                setPreviewChangesTrigger(previewChangesTrigger + 1);
              }}
            >
              Preview Results
            </button>
          </div>
        </div>
        <div className='table-definitions-editor-body'>
          <DocumentViewer
            pdfDocument={props.pdfDocument}
            parentDocumentId={null}
            filename={props.filename}
            setNotification={props.setNotification}
            showSpinner={props.showSpinner}
            documentId={props.document.id}
            hideControls={true}
            useContainerRef={true}
            filePages={props.filePages}
            loadOnlyPageIndex={props.filePages ? props.filePages[props.activePage] : props.activePage}
            loadDefaultByWidth={true}
            editTableDefinitions={true}
            showTableHighlightOnly={true}
            cancelEditTrigger={cancelEditTrigger}
            previewChangesTrigger={previewChangesTrigger}
            setShowEditDefinitions={props.setShowEditDefinitions}
            initialPdfScale={0.8}
            documentType={props.document.documentType}
            reloadGroupData={props.reloadGroupData}
            groupId={props.groupId}
            specificId={props.document.commercialInvoice?.id || props.document.packingList?.id || props.document.billOfLading?.id || props.document.supplierInvoice?.id || 0}
          />
        </div>
      </div>
    </div>
  )
}
